import styled from 'styled-components';

export const StyledContainer = styled.div`
  position: relative;

  & .dropzone {
    margin-bottom: 8px;
    cursor: pointer;
  }
`;

export const StyledDialogDropzone = styled.div`
  margin-bottom: 8px;

  & p {
    margin-bottom: 8px;
  }
`;
